import { createRoot } from "react-dom/client";
import { getContainer, init } from "../../helpers/init";
import React from "react";
import { setTranslations } from "../../helpers/i18n";
import { prepareVisState } from "../../helpers/vis";
import Vis from "./Vis";
import { Type, type Static } from "@sinclair/typebox";

const SETTINGS_SCHEMA = Type.Object({
    groups: Type.Array(
        Type.Object({
            name: Type.Optional(Type.String()),
            visIds: Type.Array(Type.String()),
        }),
    ),
    showInteractiveElements: Type.Boolean({ default: false }),
    enableIndicationView: Type.Boolean({ default: false }),
    showTooltips: Type.Boolean({ default: false }),
    addGoToNetLinks: Type.Boolean({ default: false }),
    showSearch: Type.Boolean({ default: false }),
    showMap: Type.Optional(
        Type.Object({
            apiKey: Type.String({ default: "AIzaSyBS_Hhaufu86mGLyboaytGtH0QbKuaSEQU" }),
            defaultViewCoordinates: Type.Array(Type.Number()),
            defaultZoom: Type.Number({ default: 13 }),
        }),
    ),
    shortStates: Type.Optional(
        Type.Array(
            Type.Object({
                hasConnection: Type.Optional(Type.Boolean()),
                isOn: Type.Optional(Type.Boolean()),
                hasAlarm: Type.Optional(Type.Boolean()),
                workMode: Type.Optional(Type.String()),
                name: Type.String(),
            }),
        ),
    ),
    shortStatesColors: Type.Optional(Type.Record(Type.String(), Type.String())),
    minItemWidth: Type.String({ default: "150px" }),
    maxItemWidth: Type.String({ default: "1fr" }),
});

export type Settings = Static<typeof SETTINGS_SCHEMA>;

export function run(): void {
    const state = prepareVisState<Settings>({
        groupByDeviceIfMoreThan: 1,
        maxRealtimeReadingsPerRequest: 8,
        useParallelRealtimeReadings: true,
    });
    setTranslations(["en", "ua"]);

    createRoot(getContainer()).render(
        React.createElement(Vis, {
            state,
        }),
    );
}

// TODO_FUTURE: add corresponding registers for schedules - currently some pumping visualizations doesn't support adding events (they throw an error when trying to do that).
init({}, run, false, true, SETTINGS_SCHEMA);
